import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetPlacementMutationVariables = Types.Exact<{
	input: Types.GetAdInput;
}>;

export type GetPlacementMutation = {
	__typename?: 'Mutation';
	getPlacement: {
		__typename?: 'GetAdPayload';
		bidID?: string | null;
		ads?: Array<
			| {
					__typename?: 'CreativeFreeTrialContent';
					adContent: string;
					name: string;
					adID: number;
					campaignID: number;
			  }
			| {
					__typename?: 'CreativeGenericContent';
					adContent: string;
					name: string;
					adID: number;
					campaignID: number;
			  }
			| { __typename?: 'CreativeQTVContent'; adContent: string; name: string; adID: number; campaignID: number }
			| { __typename?: 'CreativeSQTVContent'; adContent: string; name: string; adID: number; campaignID: number }
			| { __typename?: 'CreativeSRContent'; adContent: string; name: string; adID: number; campaignID: number }
			| {
					__typename?: 'CreativeSwiperContent';
					adContent: string;
					name: string;
					adID: number;
					campaignID: number;
			  }
		> | null;
	};
};

export const GetPlacementDocument = gql`
	mutation GetPlacement($input: GetAdInput!) {
		getPlacement(input: $input) {
			ads {
				adContent
				name
				adID
				campaignID
			}
			bidID
		}
	}
`;
